import type { StepConfigFor } from '../getStepConfig.types.ts';

export const MedicareVerificationStepConfig = {
  title: ({ isHealthcareProvider }) =>
    isHealthcareProvider ? 'Medicare/IHI Details' : 'Add Your Medicare/IHI Details',

  statuses: {
    NOT_STARTED: {
      label: 'Not Started',
      cta: 'Provide Details',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with adding their Medicare card or IHI number'
          : 'Please add your Medicare card details or IHI number',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with adding their Medicare card or IHI number'
          : 'Please add your Medicare card details or IHI number',
    },

    PENDING: {
      label: 'Verifying',
      cta: 'Resubmit',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their Medicare card or IHI number. Please review them and verify their details'
          : 'You have submitted your Medicare card details or IHI number. We are reviewing them and will update you shortly',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their Medicare card or IHI number. We need to review it and update the status'
          : 'Your Medicare card details or IHI number are being reviewed. We will update you shortly',
    },

    COMPLETED: {
      label: 'Verified',
      cta: 'View',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully added their Medicare card or IHI number'
          : 'You have successfully added your Medicare card details or IHI number',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully added their Medicare card or IHI number'
          : 'You have successfully added your Medicare card details or IHI number',
    },

    ERROR: {
      label: 'Verification Failed',
      cta: 'Resubmit',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'There was an issue with the Medicare card or IHI number. The patient will need to resubmit it'
          : 'There was an issue with your Medicare card details or IHI number. Please resubmit them',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'There was an issue with the Medicare card or IHI number. The patient will need to resubmit it'
          : 'There was an issue with your Medicare card details or IHI number. Please resubmit them',
    },
  },
} satisfies StepConfigFor<'MEDICARE_VERIFICATION'>;
